module.exports = require("./file");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file4/dir/index.js
 ** module id = 17
 ** module chunks = 0
 **/